import { render, staticRenderFns } from "./stufocus.vue?vue&type=template&id=d181e21c&scoped=true&"
import script from "./stufocus.vue?vue&type=script&lang=js&"
export * from "./stufocus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d181e21c",
  null
  
)

export default component.exports